<template>
  <div class="content-body" style="padding-top: 6rem">
    <div class="container-fluid">
      <div class="page-titles">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Info</a></li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'Blog' }">Data Blog</router-link>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">{{ currentRouteName }}</a>
          </li>
        </ol>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Form {{ currentRouteName }}</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Judul</label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.title"
                      @input="generateSlug"
                      type="text"
                      class="form-control"
                      placeholder="Judul Post"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Slug URL</label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.slug"
                      type="text"
                      class="form-control"
                      placeholder="Slug URL"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Kategori</label>
                  <div class="col-sm-9">
                    <select
                      v-model="editForm.id_sub_kategori"
                      class="form-control select2"
                      multiple="multiple"
                    >
                      <option
                        v-for="kategori in kategoriList"
                        :key="kategori.id"
                        :value="kategori.id"
                      >
                        {{ kategori.judul }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Thumbnail</label>
                  <div class="col-sm-9">
                    <div v-if="editForm.imagePreview" class="mb-3">
                      <img
                        :src="editForm.imagePreview"
                        alt="Thumbnail"
                        class="img-thumbnail"
                        style="max-width: 200px; max-height: 200px"
                      />
                    </div>
                    <div>
                      <input
                        type="file"
                        class="d-none"
                        ref="fileInput"
                        accept="image/*"
                        @change="handleFileUpload"
                      />
                      <button
                        type="button"
                        class="btn btn-primary btn-sm mr-1"
                        @click="triggerFilePicker"
                      >
                        Change
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Image Caption</label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.alt_image"
                      type="text"
                      class="form-control"
                      placeholder="Input Caption Image"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Deskripsi</label>
                  <textarea
                    ref="summernote"
                    class="form-control summernote"
                    id="deskripsi"
                    v-model="editForm.deskripsi"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Keyword Tag</label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.hastag"
                      type="text"
                      class="form-control"
                      placeholder="Input Keyword Tag"
                    />
                  </div>
                </div>

                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Meta SEO</h4>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">
                    Meta Title
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.meta_title"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          (editForm.meta_title?.length || 0) > 255 ||
                          (submitted && !(editForm.meta_title || '').trim()),
                      }"
                      placeholder="Input Meta Title"
                    />
                    <div
                      class="d-flex justify-content-between align-items-center mt-1"
                    >
                      <div>
                        <small
                          v-if="(editForm.meta_title?.length || 0) > 255"
                          class="text-danger font-weight-bold"
                        >
                          <i class="fa fa-exclamation-circle mr-1"></i
                          >Karakter melebihi batas maksimal (Maks. 255 karakter)
                        </small>
                        <small
                          v-else-if="
                            submitted && !(editForm.meta_title || '').trim()
                          "
                          class="text-danger"
                        >
                          <i class="fa fa-exclamation-circle mr-1"></i>Meta
                          Title wajib diisi
                        </small>
                      </div>
                      <small
                        :class="
                          (editForm.meta_title?.length || 0) > 255
                            ? 'text-danger font-weight-bold'
                            : 'text-muted'
                        "
                        class="ml-auto"
                      >
                        {{ (editForm.meta_title || "").length }}/255
                      </small>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">
                    Meta Description
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.meta_deskripsi"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          submitted &&
                          !(editForm.meta_deskripsi || '').trim(),
                      }"
                      placeholder="Input Meta Description"
                    />
                    <div
                      class="d-flex justify-content-between align-items-center mt-1"
                    >
                      <div>
                        <small
                          v-if="
                            submitted &&
                            !(editForm.meta_deskripsi || '').trim()
                          "
                          class="text-danger"
                        >
                          <i class="fa fa-exclamation-circle mr-1"></i>Meta
                          Description wajib diisi
                        </small>
                      </div>
                      <small class="text-muted ml-auto">
                        {{ (editForm.meta_deskripsi || "").length }} karakter
                      </small>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">
                    Meta Content
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.meta_content"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          submitted && !(editForm.meta_content || '').trim(),
                      }"
                      placeholder="Input Meta Content"
                    />
                    <div
                      class="d-flex justify-content-between align-items-center mt-1"
                    >
                      <div>
                        <small
                          v-if="
                            submitted && !(editForm.meta_content || '').trim()
                          "
                          class="text-danger"
                        >
                          <i class="fa fa-exclamation-circle mr-1"></i>Meta
                          Content wajib diisi
                        </small>
                      </div>
                      <small class="text-muted ml-auto">
                        {{ (editForm.meta_content || "").length }} karakter
                      </small>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">
                    Meta Name
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-9">
                    <input
                      v-model="editForm.meta_name"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          (editForm.meta_name?.length || 0) > 255 ||
                          (submitted && !(editForm.meta_name || '').trim()),
                      }"
                      placeholder="Input Meta Name"
                    />
                    <div
                      class="d-flex justify-content-between align-items-center mt-1"
                    >
                      <div>
                        <small
                          v-if="(editForm.meta_name?.length || 0) > 255"
                          class="text-danger font-weight-bold"
                        >
                          <i class="fa fa-exclamation-circle mr-1"></i
                          >Karakter melebihi batas maksimal (Maks. 255 karakter)
                        </small>
                        <small
                          v-else-if="
                            submitted && !(editForm.meta_name || '').trim()
                          "
                          class="text-danger"
                        >
                          <i class="fa fa-exclamation-circle mr-1"></i>Meta Name
                          wajib diisi
                        </small>
                      </div>
                      <small
                        :class="
                          (editForm.meta_name?.length || 0) > 255
                            ? 'text-danger font-weight-bold'
                            : 'text-muted'
                        "
                        class="ml-auto"
                      >
                        {{ (editForm.meta_name || "").length }}/255
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Status</label>
                  <div class="col-sm-9">
                    <select v-model="editForm.is_publish" class="form-control">
                      <option value="true">Publish</option>
                      <option value="false">Unpublish</option>
                    </select>
                  </div>
                </div>
                <button
                  type="button"
                  @click="goBack"
                  class="btn btn-warning btn-sm mr-1"
                >
                  Kembali
                </button>
                <button
                  type="button"
                  @click="updateData"
                  class="btn btn-primary btn-sm mr-1"
                >
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../axios";
import defaultURL from "@/config";

export default {
  name: "Edit Blog",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const summernote = ref(null);
    const fileInput = ref(null);
    const currentRouteName = computed(() => route.name);
    const editForm = ref({
      title: "",
      slug: "",
      image: null,
      imagePreview: null,
      alt_image: "",
      deskripsi: "",
      hastag: "",
      meta_title: "",
      meta_deskripsi: "",
      meta_content: "",
      meta_name: "",
      is_publish: "true",
      user: null,
      id_kategori: 6,
      id_sub_kategori: [],
    });
    const submitted = ref(false);
    const kategoriList = ref([]);
    const token = computed(() => store.state.token);
    const id_kategori = editForm.value.id_kategori;

    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get("/user", {
          headers: {
            Authorization: `Bearer ${token.value}`,
          },
        });
        if (response.status === 200) {
          editForm.value.user = response.data.id;
        } else {
          throw new Error("Failed to fetch user data");
        }
      } catch (error) {
        handleAuthError(error);
      }
    };

    const fetchData = async () => {
      const id = route.params.id;
      try {
        const response = await axiosInstance.get(`/blog/${id}`, {
          headers: {
            Authorization: `Bearer ${token.value}`,
          },
        });

        if (response.status === 200) {
          const imageUrl = `${defaultURL}/images/blogs/${response.data.data.image}`;
          editForm.value = {
            ...editForm.value,
            title: response.data.data.title,
            slug: response.data.data.slug,
            alt_image: response.data.data.alt_image,
            deskripsi: response.data.data.deskripsi,
            hastag: response.data.data.hastag,
            meta_title: response.data.data.meta_title,
            meta_deskripsi: response.data.data.meta_deskripsi,
            meta_content: response.data.data.meta_content,
            meta_name: response.data.data.meta_name,
            is_publish: response.data.data.is_publish || "true",
            user: editForm.value.user || null,
            id_kategori: response.data.data.id_kategori || 6,
            id_sub_kategori: response.data.data.id_sub_kategori
              ? response.data.data.id_sub_kategori
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "")
              : [],
            imagePreview: response.data.data.image ? imageUrl : null,
            image: response.data.data.image ? response.data.data.image : null,
          };
          $(summernote.value).summernote("code", editForm.value.deskripsi);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const sub_kategori = async () => {
      try {
        const response = await axiosInstance.get(`/kat-sub/${id_kategori}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
        });
        if (response.status === 200) {
          kategoriList.value = response.data.data;
        } else {
          Swal.fire({
            title: "Error",
            text: error.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          store.dispatch("setAuth", false);
          store.dispatch("setToken", { token: null, expiry: null });
          localStorage.clear();
          window.location.href = "/";
        });
      }
    };

    const updateData = async () => {
      submitted.value = true;

      // Validasi Meta SEO: Required
      if (
        !(editForm.value.meta_title || "").trim() ||
        !(editForm.value.meta_deskripsi || "").trim() ||
        !(editForm.value.meta_content || "").trim() ||
        !(editForm.value.meta_name || "").trim()
      ) {
        Swal.fire({
          title: "Peringatan",
          text: "Semua kolom Meta SEO yang bertanda (*) wajib diisi!",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      // Validasi Meta SEO: Max 255 Karakter
      if ((editForm.value.meta_title || "").length > 255) {
        Swal.fire({
          title: "Peringatan",
          text: `Meta Title melebihi batas maksimal (${(editForm.value.meta_title || "").length}/255 karakter)!`,
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      if ((editForm.value.meta_name || "").length > 255) {
        Swal.fire({
          title: "Peringatan",
          text: `Meta Name melebihi batas maksimal (${(editForm.value.meta_name || "").length}/255 karakter)!`,
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      editForm.value.deskripsi = $(summernote.value).summernote("code");
      const formData = new FormData();

      Object.keys(editForm.value).forEach((key) => {
        if (
          key !== "image" &&
          key !== "imagePreview" &&
          editForm.value[key] !== ""
        ) {
          formData.append(key, editForm.value[key]);
        }
      });

      if (editForm.value.image instanceof File) {
        formData.append("image", editForm.value.image);
      } else if (typeof editForm.value.image === "string") {
        formData.append("image", editForm.value.image);
      }

      try {
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }

        const response = await axiosInstance.post(
          `/blog-update/${route.params.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token.value}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          if (response.data.success === false) {
            Swal.fire("Error", `Error: ${response.data.message}`, "error");
          } else {
            Swal.fire("Success", "Data updated successfully", "success");
            router.push({ name: "Blog" });
          }
        }
      } catch (error) {
        Swal.fire("Error", `Error: ${error.message}`, "error");
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      const validTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes

      // Validate file type
      if (!validTypes.includes(file.type)) {
        Swal.fire({
          title: "Invalid File Type",
          text: "Please select an image with format jpeg, jpg, png, or svg.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        Swal.fire({
          title: "File Too Large",
          text: "Please select an image smaller than 2MB.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      // If validation passes, assign the file and create a preview
      editForm.value.image = file;
      editForm.value.imagePreview = URL.createObjectURL(file);
    };

    const triggerFilePicker = () => {
      if (fileInput.value) {
        fileInput.value.click();
      }
    };

    const goBack = () => {
      router.push({ name: "Blog" });
    };

    const generateSlug = async () => {
      editForm.value.slug = editForm.value.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      await checkTitleExistence();
    };

    const handleAuthError = (error) => {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        store.dispatch("setAuth", false);
        store.dispatch("setToken", { token: null, expiry: null });
        localStorage.clear();
        router.push({ name: "Login" });
      });
    };

    onMounted(async () => {
      await fetchUser();
      await fetchData();
      await sub_kategori();
      await nextTick(() => {
        $(summernote.value).summernote({
          height: 200,
          callbacks: {
            onChange: (contents) => {
              editForm.value.deskripsi = contents;
            },
          },
        });

        $(".select2")
          .select2()
          .val(editForm.value.id_sub_kategori)
          .trigger("change")
          .on("change", function () {
            editForm.value.id_sub_kategori = $(this).val();
          });
      });
    });

    watch(
      () => editForm.value.id_kategori,
      async (newKategori, oldKategori) => {
        if (newKategori !== oldKategori) {
          console.log("id_kategori changed:", newKategori);
          await sub_kategori();
        }
      }
    );

    return {
      currentRouteName,
      editForm,
      kategoriList,
      handleFileUpload,
      generateSlug,
      summernote,
      updateData,
      goBack,
      triggerFilePicker,
      fileInput,
      submitted,
    };
  },
};
</script>
